import './polyfill'
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { toast } from 'react-toastify';

import "react-datepicker/dist/react-datepicker.css";
import 'react-toastify/dist/ReactToastify.css';

import "@fullcalendar/core/main.css"
import "@fullcalendar/daygrid/main.css";

toast.configure({
    autoClose: 1000,
    draggable: false,
    //etc you get the idea
  })


ReactDOM.render(<App />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js